define('sortable',[
    // Libs
    'jquery', 'underscore', 'rubaxa-sortable', 'utils',
], function($, _, Sortable, U) {

    var callbacks = [
            "setData",
            "filter",
            "scrollFn",
            "onMove",
            "onStart",
            "onEnd",
            "onAdd",
            "onUpdate",
            "onSort",
            "onRemove",
            "onFilter",
            "onChoose",
            "onClone",
        ],
        sortableProto = Sortable.prototype;

    /**
     * Wraps RubaXa/Sortable and applies default options related to the project.
     * @param  {jQuery} $elem the list element.
     * @param  {Object} options Sortable options
     * @return {Sortable} instance.
     */
    var SortableExtension = function($elem, options) {
        options = _.extend({
            // delay: 25,
            animation: 125,
            // handle: ".handle",
            ghostClass: "ghost",
            chosenClass: "dragged",
        }, options);

        this.$lastList = null;

        var context = options.context;
        if (context) {
            _.each(callbacks, function(fnName) {
                applyContext(options, fnName, context);
            }, this);
        }

        // Add drag:enter and drag:leave callbacks to onMove
        options.onMove = _.wrap(options.onMove, this._onMove);
        options.onEnd = _.wrap(options.onEnd, this._onEnd);

        return sortableProto.constructor.call(this, $elem.get(0), options);
    };

    SortableExtension.prototype = _.extend({}, sortableProto, {
        constructor: SortableExtension,

        isFiltered: function($elem) {
            return $elem.hasClass('drag-filter');
        },

        toggleClass: function($el, val) {
            $el.toggleClass(this.options.chosenClass + " " + this.options.ghostClass, val);
        },

        /**
         * Wraps the onEnd callback to trigger drag:leave on the last
         * target lists element.
         * @param  {Function|undefined} onEnd callback if any.
         */
        _onEnd: function(onEnd) {
            var $lastList = this.$lastList;
            if ($lastList) $lastList.trigger("drag:leave");
            this.$lastList = null;
            if (onEnd) return onEnd.apply(this.options.context, Array.prototype.slice.call(arguments, 1));
        },

        /**
         * Wraps the onMove callback to trigger drag:enter and drag:leave on
         * target lists element.
         * @param  {Function|undefined} onMove callback if any.
         * @param  {Event} e   Sortable event
         */
        _onMove: function(onMove, e) {
            var $to = $(e.to),
                $lastList = this.$lastList;
            if (!$to.is($lastList)) {
                if ($lastList) $lastList.trigger("drag:leave");
                $lastList = this.$lastList = $to;
                $to.trigger("drag:enter");
            }
            if (onMove) return onMove.apply(this.options.context, Array.prototype.slice.call(arguments, 1));
        },

    });

    /**
     * Static constructor
     * @param  {jQuery} $elem list element
     * @param  {Object} options to pass to Sortable
     * @return {Sortable} instance
     */
    SortableExtension.create = function($elem, options) {
        return new SortableExtension($elem, options);
    };

    /**
     * Binds a callback (as a string or function) inside an object, by name.
     * @param  {Object} obj to get the callback from, then store the bound callback.
     * @param  {String} fnName  callback property to use.
     * @param  {Object} context to apply.
     */
    function applyContext(obj, fnName, context) {
        var callback = obj[fnName];
        if (!callback) return;
        if (context && _.isString(callback)) callback = context[callback];
        if (_.isFunction(callback)) obj[fnName] = callback.bind(context);
    }

    return SortableExtension;

});

